import { useRouter } from 'next/router';
import cn from 'classnames/dedupe';
import { useShallow } from 'zustand/react/shallow';
import { useStore } from '../../../store/useStore';
import React, { useCallback, useState } from 'react';
import ProgressStepper from '../components/feedback/ProgressStepper';
import Stepper from '../components/feedback/stepper';
import Percentage from '../components/feedback/questionsType/percentage';
import Layout from '../layout';
import styles from '../components/feedback/styles/StepQuestion.module.css';
import questionStyles from '../components/feedback/styles/question.module.css';
import SendEvents from '../../../components/sendEvents/sendEvents';
import { VALORE_CASA, ETA } from '../../../config/paths';
const STEP_CONFIG = {
  totalSteps: 10,
  currentStep: 2,
  currentPercentage: 20, 
  showProgressSpinner: false,
  showStepper: true,
  intro: null,
  title: null,
  description: null
};
const CURRENT_QUESTION = {
  step: 1,
  question_label: "💰 Qual è l'importo del mutuo che vorresti richiedere?",
  question_type: 'percentage',
  question_placeholder: 'es. 140.000',
  var_name: 'step_1',
  min_value: '30000',
  max_value: '10000000',
  required: 'true',
  show_percentage: true,
  percentage: 20,
  last_question: false,
  suggestion: "I tassi più convenienti si trovano su mutui di importo inferiore all'80% rispetto al valore della casa.",
  question_answers: []
};
export default function ImportoMutuo({intro=null, variation=null}) {
  const router = useRouter();
  const [isLoading, setIsLoading] = useState(false);
  const { importoMutuo, setImportoMutuo, userRequestId, landedIn, passedThrough } = useStore(
    useShallow(state => ({
      importoMutuo: state.importoMutuo,
      userRequestId: state.userRequestId,
      setImportoMutuo: state.setImportoMutuo,
      landedIn: state.landedIn,
      passedThrough: state.passedThrough,
    })),
  );

  const params = new URLSearchParams(router.query);

  const valInputTranslator = valIn => {
    let val = Number(valIn.replaceAll('.', ''));
    if (val >= 250000) {
      val = 'Alto';
    } else if (val < 250000 && val >= 150000) {
      val = 'Medio';
    } else {
      val = 'Basso';
    }
    return val;
  };

  // MIXPANEL VALORE STEP
  SendEvents({
    sendOnEnter: false,
    sendOnExit: true,
    name: '1 - importo mutuo',
    getData: () => ({
      answer: valInputTranslator(importoMutuo),
      current_step: 0,
      user_req_id: userRequestId,
      landedIn: landedIn,
      passedThrough: passedThrough,
    }),
  });

  const next = useCallback(async () => {
    if (isLoading) return;
    try {
      setIsLoading(true); 
      if (variation==1) {
        router.push(VALORE_CASA + '?' + params.toString() + ((params.toString().length > 0 ? '&' : '') + 'variation=1'));
      } else if (params.get('variation') == '1') {
          router.push(VALORE_CASA + '?' + params.toString());
      } else {
        router.push(ETA + '?' + params.toString());
      }
    } catch (error) {
      console.error('Navigation error:', error);
    } finally {
      setIsLoading(false);
    }
  }, [router, isLoading, variation]);


  const prev = useCallback(async () => {
    if (isLoading) return;
    try {
      setIsLoading(true);
      await router.push(VALORE_CASA + '?' + params.toString());
    } catch (error) {
      console.error('Navigation error:', error);
    } finally {
      setIsLoading(false);
    }
  }, [router, isLoading]);

  return (
    <div id="importo_mutuo" className={cn(styles.stepQuestionsContainer)}>
      {STEP_CONFIG.showProgressSpinner && <ProgressStepper currentStep={STEP_CONFIG.currentStep} />}
      {intro && variation == 1 && (
        <div className="step-page-intro">
          <h1 style={{ fontWeight: '700', lineHeight: '25px', fontSize: '15px', margin: '0' }}>{intro}</h1>
        </div>
      )}
      {STEP_CONFIG.title && <div className={styles.titleText}>{STEP_CONFIG.title}</div>}
      {STEP_CONFIG.showStepper && (
        <Stepper intro={STEP_CONFIG.intro} question={{ percentage: variation == 1 ? 10 : STEP_CONFIG.currentPercentage }} />
      )}
      {STEP_CONFIG.description && <div className={styles.descriptionText}>{STEP_CONFIG.description}</div>}
      <div className={questionStyles.question}>
        <div className={questionStyles.label}>
          <Percentage
            variation={params.get('variation') || variation}
            value={importoMutuo}
            onChange={setImportoMutuo}
            question={CURRENT_QUESTION}
            next={next}
            prev={prev}
            isLoading={isLoading}
          />
        </div>
      </div>
    </div>
  );
}
ImportoMutuo.getLayout = function getLayout(page) {
  return <Layout>{page}</Layout>;
};